import _ from 'lodash';
import { RentalChargeTypes } from '../../../constants';

const parseRentalCarCharges = (vehicleCharges) => {
  try {
    if (!vehicleCharges || !vehicleCharges.length) return {};
    const baseRate =
      vehicleCharges &&
      _.find(vehicleCharges, (c) => c.chargeType === RentalChargeTypes.BaseRateTotal);
    const approxTotalRate =
      vehicleCharges &&
      _.find(vehicleCharges, (c) => c.chargeType === RentalChargeTypes.ApproximateTotalPrice);
    const taxesAndFees =
      baseRate &&
      approxTotalRate &&
      baseRate.amount > 0 &&
      approxTotalRate.amount > 0 &&
      approxTotalRate.amount >= baseRate.amount
        ? approxTotalRate.amount - baseRate.amount
        : undefined;
    const otherCharges =
      vehicleCharges && _.filter(vehicleCharges, (c) => c !== baseRate && c !== approxTotalRate);
    const doShowTaxesAndFees = taxesAndFees !== undefined;

    return {
      baseRate,
      approxTotalRate: approxTotalRate || {},
      taxesAndFees,
      otherCharges,
      doShowTaxesAndFees,
    };
  } catch (error) {
    return {};
  }
};

export default parseRentalCarCharges;
